import { useDispatch, useSelector } from "react-redux";
import GridSidePane from "../components/grid/GridSidePane";
import { selectRecentDocuments } from '../reducers/recentDocumentsReducer';
import { fetchAllDocuments } from '../fetch/fetchAllDocuments.js';
import { selectLangObj } from "../reducers/langReducer.js";
import { useEffect, useRef, useState } from "react";
import GridElement from "../components/grid/GridElement.js";
import { NavLink, useSearchParams } from "react-router";

import { resetGrid, selectDocuments, selectPage, selectTotalCount, selectTotalPages, selectLoadingSingleDocument, selectFilter, setPage, resetSingleDocument, setGridType, setRbr, clearGrid, setUser, setFilter, setPerson } from "../reducers/gridReducer.js"
import FilterDTO from "../models/Filters.ts";
import { useParams } from 'react-router';
import GridType, { GridTypeMap } from '../models/GridType.ts';
import { selectLoader, setLoading } from '../reducers/loaderReducer.js';

function Grid() {
    const documents = useSelector(selectDocuments);
    const loading = useSelector(selectLoadingSingleDocument);
    const dispatch = useDispatch();
    const langObj = useSelector(selectLangObj);
    const endRatio = 0.95;

    const page = useSelector(selectPage);
    const count = useSelector(selectTotalCount);
    const totalPages = useSelector(selectTotalPages);
    const filter = useSelector(selectFilter);
    const didMountRef = useRef(false);


    // const [data, setData] = useState([]);

    const params = useParams();


    const appendItems = (newpage = null) => {

        // Setting up filterProperties object with empty strings
        if (newpage) {
            dispatch(setPage(newpage));
        }
        if (!newpage || newpage == page) {
            dispatch(fetchAllDocuments(filter));
        }
    }

    useEffect(() => {

        let param = GridTypeMap[params.type];
        param = param || null;
        dispatch(clearGrid());
        dispatch(setGridType(param));
        dispatch(setPerson(null));

        dispatch(setUser(null));
        if (params.person) {

            if (params.type == GridType.Person) {

                dispatch(setPerson(decodeURIComponent(params.person)));

            } else {
                dispatch(setUser(decodeURIComponent(params.person)));

            }
        }

    }, []);
    useEffect(() => {
        dispatch(fetchAllDocuments(filter));
    }, [filter.PageNumber]);

    useEffect(() => {
        if (didMountRef.current) {
            appendItems();
        } else {
            didMountRef.current = true;
        }


    }, [filter.Рбр, filter.Тип, filter.Прикупио]);

    useEffect(() => {

    }, [documents]);
    function getLink(e) {
        var linkType = ["Фото", "Документи", "Слике", "Родослови"];
        var linkPType = ["Видео", "Текст", "Књига"];

        if (linkType.includes(e.тип))
            return e.линк;
        else if (linkPType.includes(e.тип))
            return e.линкП;
        return e.линк;
    }
    function getHref(e) {
        var link;
        var target = "";

        var linkType = ["Фото", "Документи", "Слике", "Родослови"];
        var linkPType = ["Видео", "Текст", "Књига"];

        if (linkType.includes(e.тип))
            link = "/Document/" + e.рбр;
        else if (linkPType.includes(e.тип)) {
            link = e.линк;
            target = "_blank";
        }

        return { link, target };
    }


    function getLink(e) {
        var linkType = ["Фото", "Документи", "Слике", "Родослови"];
        var linkPType = ["Видео", "Текст", "Књига"];

        if (linkType.includes(e.тип))
            return e.линк;
        else if (linkPType.includes(e.тип))
            return e.линкП;
        return e.линк;
    }

    return (

        <div key={params.type + "_" + params.person} className="h-full flex flex-col md:flex-row relative">

            {/* <GridSidePane>

            </GridSidePane> */}

            <div className="flex-grow grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-12 p-6 md:p-12 backdrop-blur-md   h-full overflow-y-scroll" onScroll={(e => {
                let el = e.currentTarget;


                if ((el.scrollTop + el.clientHeight) / el.scrollHeight > endRatio) {
                    if (!loading) {

                        appendItems(page + 1);
                    }
                }

            })}>
                {

                    documents ? (documents.map(e => {

                        let { link, target } = getHref(e);

                        return (
                            <NavLink to={link} target={target} end>
                                <GridElement item={{ title: e.наслов, src: getLink(e) }}></GridElement>
                            </NavLink>
                        )

                    }
                    )) : ""

                }
            </div>
        </div>






    )
}
export default Grid;